const defaultNuevaCuentaForm = {
    nombre: null,
    apellidos: null,
    rol: { "id": 4 },
    documento: null,
    tipoDocumento: null,
    numerosContacto: [],
    email: null,
    password: null,
    password2: null,
    direccion: null,
    cp: null,
    localidad: null,
    costoGeneral: null,
    nuss: null,
    iban: null,
    talla: null,
    estado: 'ALTA',
    tipoComercial: 'TIENDA',
    username: null,
    maxHolidays: null,
    holidaysType: null,
    laborableWeekdays: [],
}

export default defaultNuevaCuentaForm;
